export default __webpack_public_path__ + "images/WY.60de49b.png";